module.exports = __webpack_public_path__ + "static/DemoRequest-image-03-2bdada9b05176769302077ba424a00c4.jpg";